import CityPageTemplate from "../city-template/CityPageTemplate";
import { grandPrairieConfig } from "./data";

export default function GrandPrairiePage() {
  return <CityPageTemplate config={grandPrairieConfig} />;
}